import React from 'react'
import { CircularProgress, Grid, Icon, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core'
import { onGetCurrencyValue, onGetDateFormat, onGetFullname } from '../../../../shared/utility'
import SearchBar from '../../../../components/Actions/SearchBar'
import ActionBar from '../../../../components/Actions/ActionBar'
import empty from '../../../../assets/placeholders/nosales.png'
import tableStyles from '../../../../styles/tableStyles'
import StatusData from '../../../../components/Structure/DisplayData/StatusData'
import DownloadButton from '../../../../components/Actions/DownloadButton'
import FilterButton from '../../../../components/Actions/FilterButton'
import MonthFilter from '../../../../components/Actions/MonthFilter'

const SimpleTable = props => {

    const classes = tableStyles()
    const { content, data, onAddRegister, search, onChangeSearch, catalogs, total, tableFilter, onUpdateTableFilter, 
        onSelectedItem, loading, startDate, endDate, onChangeDate, onDownloadReceipt, onUpdateFilters, filters} = props

    const header = content.header

    const all_option = [{value:-1, label:'Todos'}]

    return(
        <div>
            <div className={classes.toolbar}>
                <Grid container justify='flex-end' spacing={2} alignItems='center'  > 
                    <Grid item><FilterButton options={catalogs.sales_statuses} selected={filters.status} onChange={(value)=>onUpdateFilters('status', value)} /></Grid>
                    <Grid item><FilterButton options={[...all_option, ...catalogs.receipt_types]} selected={filters.receipt} onChange={(value)=>onUpdateFilters('receipt', value)} /></Grid>
                    <Grid item><MonthFilter  value={startDate} onChange={(value)=>onChangeDate(value,'start_date')} /></Grid>
                    <Grid item>-</Grid>
                    <Grid item><MonthFilter  value={endDate} onChange={(value)=>onChangeDate(value,'end_date')} /></Grid>
                    <Grid item xs></Grid>
                    {/* <Grid item><SearchBar value={search} onChange={onChangeSearch} /></Grid> */}
                    {/* <Grid item><IconButton className={classes.button} onClick={onAddRegister}><Icon style={{fontSize:40}} >add</Icon></IconButton></Grid> */}    
                </Grid>
            </div>
            {loading ? (
                <Grid container justify='center'>
                    <Grid item><CircularProgress size={32}/></Grid>
                </Grid>
            ) : null}          
            {data && data.length ? (
                <div className={classes.tableWrapper}>
                    <Table className={classes.table}>
                        {header ? (
                            <TableHead>
                                <TableRow>
                                    {header.map(item=>{
                                        return(
                                            <TableCell padding='default' className={classes.cellHeader} key={item.id.toString()}>
                                                <Typography  variant='subtitle2'>{item.label}</Typography>
                                            </TableCell>
                                        )
                                    })}
                                </TableRow>
                            </TableHead>
                        ):null}
                        <TableBody>
                            {data.map((item,key) => {
                                const {id_order, sold_date, price_type, order_status_id, seller, total, receipt_type, generated_receipt, invoiced, payment_type} = item

                                return(
                                    <TableRow key={key.toString()} className={classes.row} >
                                        <TableCell className={classes.cell} onClick={() => onSelectedItem(id_order)}><Typography>{id_order}</Typography></TableCell>
                                        <TableCell className={classes.cell} onClick={() => onSelectedItem(id_order)}><Typography>{onGetDateFormat(sold_date, 'DD/MM/YYYY')}</Typography></TableCell> 
                                        <TableCell className={classes.cell} onClick={() => onSelectedItem(id_order)}><StatusData catalogs={catalogs.orders_statuses} id={order_status_id} /></TableCell>
                                        <TableCell className={classes.cell} onClick={() => onSelectedItem(id_order)}><Typography>{seller}</Typography></TableCell>
                                        <TableCell className={classes.cell} onClick={() => onSelectedItem(id_order)}><Typography>{onGetCurrencyValue(total)}</Typography></TableCell>
                                        <TableCell className={classes.cell} onClick={() => onSelectedItem(id_order)}><div className={classes.payment_type}>{payment_type}</div></TableCell>
                                        <TableCell className={classes.cell_center}  onClick={() => onSelectedItem(id_order)}><div className={classes.receipt}>{receipt_type}</div></TableCell>
                                        <TableCell className={classes.cell_center} ><DownloadButton disabled={!(Boolean(invoiced))} onClick={()=>onDownloadReceipt(generated_receipt, invoiced, id_order)} /></TableCell>
                                    </TableRow>
                                )
                            })}
                            
                        </TableBody>
                    </Table>
                </div>           
            ): null}   
            {data && data.length ? <div className={classes.actions}>
                <ActionBar total={total} tableFilter={tableFilter} onUpdateTableFilter={onUpdateTableFilter}/>
            </div> : null}
            {data.length === 0 && !loading  ? (
                <div className={classes.nodata}>
                    <Grid container justify='center' alignItems='center' direction='column'>
                        <Grid item>
                            <div className={classes.img_container}>
                                <img src={empty} alt='' className={classes.empty}/>
                            </div>
                        </Grid>
                        <Grid item>
                            <Typography>{content.nodata}</Typography>
                        </Grid>
                    </Grid>
                </div>              
            ) : null}        
        </div>
    )
}

export default SimpleTable